import { Grid, Typography } from "@mui/material";
import { FormDataType } from "DataTypes/Form";
import { FC, Fragment, useEffect, useState } from "react";
import { commonFormSwitch, ControlledBoxSizeSwitch } from "Utils/SwitchCases";
import { DataArr } from "./Data";
import DateTime from "Utils/DateTime";
import { LoggedTimeType } from "DataTypes/Services/Patient.type";
import DataFormatter from "Utils/DataFormatter";
import { ListInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";

interface ViewLogDetailsProps {
  row: LoggedTimeType
}

const ViewLogDetails: FC<ViewLogDetailsProps> = ({ row }) => {
  const {
    addTimeLogType,
    addRPMTimeLogType,
    programList,
    trainingReq,
  }: ListInitialStateType = useSelector((state: any) => state?.list);
  const RPMTimeLogList = [...addTimeLogType, ...addRPMTimeLogType];
  const [formData, setFormData] = useState<FormDataType[]>(
    structuredClone(DataArr)
  );
  const prgDropData = DataFormatter.FormatDropdownData(
    programList,
    "id",
    "abbrevation",
    "id"
  );

  useEffect(() => {
    row && initialiseFormData(row)
  }, [row]);

  const initialiseFormData = (rowData: LoggedTimeType): void => {
    const formArr = structuredClone(formData);
    formArr[0].dropValue = rowData?.programId;
    formArr[0].dropArr = prgDropData;
    formArr[1].value = rowData?.activity;
    formArr[2].value = DateTime.FormatIntoDateTime(rowData?.startdatetime);
    formArr[3].value = DateTime.FormatIntoDateTime(rowData?.enddatetime);
    formArr[4].dropArr =
      rowData?.programId == 5 ? RPMTimeLogList : addTimeLogType;
    formArr[4].dropValue = rowData?.activitytype;
    formArr[5].value = rowData?.duration;
    formArr[6].dropArr = trainingReq;
    formArr[6].dropValue = rowData?.interactiveCommunication ? "Yes" : "No";
    formArr[6].boxType = rowData?.programId == 5 ?
      "single-select-drop" :
      "empty-block";
    formArr[7].value = rowData?.note;
    setFormData(formArr);
  };

  return (
    <Fragment>
      <Grid container columnSpacing={2} sx={{ mb: 1 }}>
        {formData && formData.length > 0
          ? formData.map((el: FormDataType) => {
            return (
              <Grid
                key={el.id}
                item
                {...ControlledBoxSizeSwitch(el.boxSize)}
              >
                {commonFormSwitch({
                  formObj: el,
                })}
              </Grid>
            );
          })
          : null}
      </Grid>
      <Typography my={1} variant="body2">
        {"Note : Start Time, End Time and Created Time " +
          "will be converted and shown in Location's time zone."}
      </Typography>
    </Fragment>
  );
};

export default ViewLogDetails;